import { defaultAxiosInstance } from '../config/axiosConfig';

/**
 * RBAC / session-bootstrap service.
 *
 * Wraps the identity + effective-permission endpoints used to gate the whole UI.
 * Uses the standard x-api-key axios instance (defaultAxiosInstance) — the same
 * auth every normal call uses today.
 *
 * The Platform Admin (§4) and Company Admin (§5) console endpoints are added in
 * later phases; this file intentionally only covers the Phase-1 foundation.
 */
class RbacService {
  /**
   * Basic profile of the current user.
   * → { id, email, first_name, last_name, platform, company_id, is_active }
   */
  async getMe() {
    const response = await defaultAxiosInstance.get('/user/me');
    return response.data;
  }

  /**
   * Effective permissions for the current user — the single call that gates the UI.
   * → {
   *      permissions: string[],   // already (roles ∩ envelope), wildcard-expanded
   *      roles: string[],
   *      is_platform_admin: boolean,
   *      company: { id, name, is_active, is_partner_home } | null,
   *      entitlements: string[] | null,   // enforced set: company ∩ partner limits
   *      tier: 'platform' | 'partner' | 'company' | 'none',
   *      partner: { id, name, is_active, home_company_id } | null,
   *      is_partner_admin: boolean,
   *      partner_permissions: string[],   // partner_* keys; drives the Partner area
   *    }
   * `partner` is set for partner staff (company.is_partner_home) AND for users of
   * a partner's client company ("Managed by …").
   */
  async getMyPermissions() {
    const response = await defaultAxiosInstance.get('/user/me/permissions');
    return response.data;
  }
}

const rbacService = new RbacService();
export default rbacService;
